export const studentURL = (student_id) => {
	if (!student_id) {
        console.error("student_id is missing!");
        return;
    }
	var encodedId = btoa(String(student_id));
	var path = js_base_path + students_names("multi", 0, 0) + '/seprofil/profil?key_id=' + encodedId;
	window.location.href = path;
};
